import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, ref, Ref } from 'vue';
import { useRoute } from 'vue-router/composables';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  BaseText,
  Row,
  HeadingDisplay,
  ListDisplay,
  SkeletonLoader,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { InputMoney } from '@/modules/transaction/components/InputMoney';

import {
  getProductWithdrawAmount,
  IWithdrawDetailsV2
} from '@/modules/transaction/services/product-withdraw';

import { errorText, errorStatus, listDetails, EProductTypes } from './helpers';
import { debounce } from 'lodash-es';


export default /*#__PURE__*/_defineComponent({
  __name: 'WithdrawStep',
  setup(__props) {

const route = useRoute();

const withdrawDetails = inject('withdrawDetails') as Ref<IWithdrawDetailsV2>;
const isFetchingReview = inject('isFetchingReview') as Ref<boolean>;
const productId = inject('productId') as Ref<string>;

const fetchWithdrawReview = inject('fetchWithdrawReview', (amount: number) => ({
  amount
}));

const isLoading = ref(false);
const updateValue = ref(false);
const isLoadingAmount = ref(false);
const netBalance = ref('R$ 0,00');
const isButtonDisabled = ref(false);

const withdrawInput = ref({
  value: 0,
  formatted: ''
});

const productType = computed(() => {
  const { type } = route.params;
  return type;
});

const status = computed(() => {
  return errorStatus(
    withdrawDetails.value,
    withdrawInput.value.value,
    productType.value
  );
});

const helperText = computed(() => {
  return errorText(
    withdrawDetails.value,
    withdrawInput.value.value,
    productType.value
  );
});

const details = computed(() => {
  return listDetails(
    withdrawDetails.value,
    netBalance.value,
    productType.value,
    isLoadingAmount.value
  );
});

const showButtons = computed(() => {
  return productType.value !== EProductTypes.FUNDS;
});

const shortcuts = computed(() => {
  return productType.value === EProductTypes.FUNDS
    ? withdrawDetails.value.buttons
    : [];
});

const incrementValue = computed((): number => {
  return withdrawDetails.value.increment.value;
});

const minimumWithdraw = computed(() => {
  return withdrawDetails.value.minimumRedemption.value;
});

const totalBalance = computed(() => {
  return withdrawDetails.value.availableToRedemption.value;
});

const isDisabled = computed(() => {
  return (
    withdrawInput.value.value <= 0 ||
    status.value === 'error' ||
    isButtonDisabled.value
  );
});

const debounceChangeValue = debounce(async data => {
  onChangeValue(data);
}, 500);

function onChangeValue(data: {
  value: number;
  formatted: string;
  increment: boolean;
}) {
  withdrawInput.value = data;
  netBalance.value = 'R$ 0,00';
  isButtonDisabled.value = true;

  if (data.increment) {
    const isTotal = data.value === totalBalance.value;
    const meetsMinimum = data.value >= minimumWithdraw.value;

    if (isTotal || meetsMinimum) {
      fetchWithdrawAmount(data.value);
    }
  }
}

function handleClick() {
  fetchWithdrawReview(withdrawInput.value.value);
}

function handleBlur() {
  const value = withdrawInput.value.value;
  const isTotal = value === totalBalance.value;

  if (value < minimumWithdraw.value && !isTotal) {
    netBalance.value = 'R$ 0,00';
    return;
  }

  fetchWithdrawAmount(value);
}

async function fetchWithdrawAmount(amount: number) {
  isLoadingAmount.value = true;

  try {
    const data = await getProductWithdrawAmount(productId.value, amount);

    netBalance.value = data.netBalance.formatted;

    isButtonDisabled.value = false;
  } catch (e) {
    console.error(e);
  } finally {
    isLoadingAmount.value = false;
  }
}

return { __sfc: true,route, withdrawDetails, isFetchingReview, productId, fetchWithdrawReview, isLoading, updateValue, isLoadingAmount, netBalance, isButtonDisabled, withdrawInput, productType, status, helperText, details, showButtons, shortcuts, incrementValue, minimumWithdraw, totalBalance, isDisabled, debounceChangeValue, onChangeValue, handleClick, handleBlur, fetchWithdrawAmount, NebraskaColors, BaseText, Row, HeadingDisplay, ListDisplay, SkeletonLoader, ButtonContainer, ButtonPrimary, InputMoney }
}

})